import { Helmet } from "react-helmet-async";
import { TERMS_VERSION, termsIntroduction, termsSections, fairUseIntroduction, fairUseSections } from "../content/membershipLegal";

type Props = { policy: "terms" | "fair-use" };
export default function MembershipLegalPage({ policy }: Props) {
  const isTerms = policy === "terms";
  const title = isTerms ? "Sanctuary Membership Terms and Conditions" : "Sanctuary Fair Use Policy";
  const sections = isTerms ? termsSections : fairUseSections;
  return (
    <main className="legal-page">
      <Helmet><title>{`${title} | Calm But Capable`}</title><meta name="robots" content="noindex, nofollow" /></Helmet>
      <header>
        <a href="/sanctuary">Back to Sanctuary membership</a>
        <h1>{title}</h1>
        <p className="legal-version">{TERMS_VERSION}</p>
      </header>
      <div className="legal-actions">
        <button type="button" onClick={() => window.print()}>Print or save as PDF</button>
        <a href={isTerms ? "/fair-use" : "/terms"}>{isTerms ? "Read the Fair Use Policy" : "Read the membership terms"}</a>
      </div>
      {(isTerms ? termsIntroduction : fairUseIntroduction).map((text, i) => <p key={i}>{text}</p>)}
      <nav className="legal-contents" aria-label="Contents">
        <h2>Contents</h2>
        <ul>{sections.map(section => <li key={section.id}><a href={`#${section.id}`}>{section.title}</a></li>)}</ul>
      </nav>
      {sections.map(section => (
        <section key={section.id} id={section.id}>
          <h2>{section.title}</h2>
          {section.paragraphs.map((text, i) => <p className="legal-paragraph" key={i}>{text}</p>)}
        </section>
      ))}
      <p><a href="#top" onClick={(event) => { event.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}>Back to top</a></p>
    </main>
  );
}
